import React, { type ReactNode, createContext, useCallback, useContext, useState } from 'react';

type SearchRefreshContextType = {
  searchRefreshKey: number;
  refreshRecentSearches: () => void;
};

const SearchRefreshContext = createContext<SearchRefreshContextType | undefined>(undefined);

type SearchRefreshProviderProps = {
  children: ReactNode;
};

export const SearchRefreshProvider = ({ children }: SearchRefreshProviderProps) => {
  const [refreshKey, setRefreshKey] = useState<number>(0);

  const refreshRecentSearches = useCallback(() => {
    setRefreshKey((prev) => prev + 1);
  }, []);

  return (
    <SearchRefreshContext.Provider value={{ searchRefreshKey: refreshKey, refreshRecentSearches }}>
      {children}
    </SearchRefreshContext.Provider>
  );
};

export const useSearchRefresh = (): SearchRefreshContextType | undefined => {
  const context = useContext(SearchRefreshContext);
  return context;
};
